export const sv = {
    "TRIGGER_LISTEN": "Lyssnar efter triggers",
    "ASSIST_EMPTY_MSG": "Agent AI lyssnar aktivt på din konversation och är redo att hjälpa automatiskt när den triggas.",
    "MYBOT_TRIGGET_LISTEN": "Inga aktiva My Bot-uppgifter för närvarande",
    "MYBOT_EMTPY_MSG": "För att starta en uppgift på My Bot, gå till sökfliken och välj \"Kör med agentens indata\" för din önskade uppgift.",
    "PROACTIVE_MODE": "Proaktivt läge",
    "SETTINGS": "Inställningar",
    "HELP_AND_SUPPORT": "Hjälp & Support",
    "HELP": "Hjälp",
    "LANGUAGE": "Språk",
    "THEME": "Tema",
    "AUTOMATIC": "Automatiskt",
    "DARK": "Mörkt",
    "LIGHT": "Ljust",
    "THEME_DESC": "Detta kommer att använda ditt systems standardläge",
    "DOCUMENTATION": "Dokumentation",
    "DOC_DESC": "Kolla in våra detaljerade dokumentationsartiklar.",
    "FAQ_U": "FAQ",
    "FILE_NAME":"Filnamn",
    "FAQ_DESC": "Se vanliga frågor om Agent AI.",
    "KORE_ACADEMY": "Kore Akademin",
    "AUTO_SCROLL_TOOLTIP":"Kontrollerar automatisk rullning av Assist-fliken, Min bot och Transkript-flikens innehåll",
    "KORE_ACA_DESC": "Lär dig mer om Agent AI genom akademikurser.",
    "SEARCH": "Sök",
    "MY_BOT": "Min Bot",
    "ASSIST": "Assistera",
    "TRANSCRIPT": "Transkript",
    "HISTORY": "Historia",
    "STARTOVER": "Börja om",
    "RESTART_INPUTS": "Starta om med fångade indata",
    "ASKCUSTOMER": "Fråga Kunden",
    "TAB_TEXT":"Inga flikar är aktiverade! Aktivera minst en flik",
    "TELLCUSTOMER": "Berätta för Kunden",
    "WELCOME_MSG": "Välkomstmeddelande",
    "TAP_SEARCH":"Tryck för att söka",
    "SEND": "Skicka",
    "SENT": "Skickat",
    "AWAITING": "Väntar på svar | Skriv för att fortsätta",
    "OVERRIDE": "Skriv för att fortsätta",
    "OVERRIDE_FILE": "Bifoga fil för att fortsätta",
    "ACCEPT_RESPONSE": "Svar accepterat",
    "AGENT_ENTERED": "Agenten gick in",
    "EXPECTED_FORMAT": "Förväntat format",
    "INPUT_VALUES": "Indatavärden",
    "RESTART": "Starta om",
    "START_OVER": "Börja om",
    "RESTART_CAPTURE": "Starta om med fångade indata",
    "CANCEL": "Avbryt",
    "INTERRUPT_DIALOG": "AVBRUTET DIALOGUPPGIFT",
    "RUN": "Kör",
    "RUN_AGENT": "Kör med agentens indata",
    "STEP": "Steg",
    "DIALOG_TASK": "Dialoguppgift",
    "FAQ": "FAQ",
    "SNIPPET": "Svar",
    "ARTICLE": "Webbsidor",
    "FILE": "Filer",
    "SUGGESTED": "Föreslagen",
    "ALL_DIALOG": "Alla dialoguppgifter",
    "DIALOG_TEXT": "Dialog",
    "INTENT_IDENTIFIED": "Kundyttrande",
    "NOT_WHAT_LOOKING": "Fel förslag?",
    "BOT": "Bot",
    "CUSTOMER": "Kund",
    "YOU": "Du",
    "TERMINATE_CONV": "Avsluta dialoguppgift",
    "TERMINATE_CONV_DESC": "Är du säker på att du vill avsluta dialoguppgiften? Agent AI kommer inte längre att kunna ge förslag.",
    "YES_TERMINATE": "Ja, avsluta",
    "NO_CANCEL": "Nej, avbryt",
    "OVERRIDE_CONTINUE": "Fortsätt med överskridsläge",
    "SUMMARY_TEXT": "Sammanfattning",
    "SUBMIT": "Skicka in",
    "INTERRUPT_OCCURED": "Avbrott inträffade",
    "IDENTIFIED_INTENT": "Identifierad avsikt",
    "INTERRUPT_DESC": "Att köra detta kommer att avsluta din pågående dialoguppgift.",
    "ACCEPT_RUN": "Acceptera och kör",
    "RUN_LATER": "Kör senare",
    "KNOW_MORE": "Läs mer",
    "MORE_TEXT": "Mer",
    "LESS_TEXT": "Mindre",
    "VIEW_MORE": "Visa mer",
    "VIEW_LESS": "Visa mindre",
    "SHOW_MORE_FAQ": "Visa fler FAQ",
    "SHOW_LESS_FAQ": "Visa färre FAQ",
    "SHOW_MORE_ARTICLE": "Visa fler webbsidor",
    "SHOW_LESS_ARTICLE": "Visa färre webbsidor",
    "SHOW_MORE_SNIPPET": "Visa fler svar",
    "SHOW_LESS_SNIPPET": "Visa färre svar",
    "SHOW_MORE_FILES": "Visa fler filer",
    "SHOW_LESS_FILES": "Visa färre filer",
    "VIEW_ALL_DIALOG": "Visa alla dialoger",
    "VIEW_FEW_DIALOG": "Visa några dialoger",
    "HELP_FULL": "Hjälpsamt?",
    "THANKYOU": "Tack!",
    "EXPAND_MORE": "Expandera / Mer",
    "CLOSE_TEXT": "Stäng",
    "STARTED": "Startade",
    "ENDED": "Slutade",
    "VIEW_FULL_ARTICLE": "Visa webbsida",
    "VIEW_FULL_FILE": "Visa fil",
    "COPIED": "Kopierat",
    "SENTI_ANALY": "Sentimentanalys",
    "WRONG_SUGGESTION": "Fel förslag",
    "INCORRECT_INTENT": "Felaktig avsikt",
    "ACCIDENTAL_CLICK": "Oavsiktlig klickning",
    "TIME_TAKING": "Tidskrävande",
    "OTHER": "Annan",
    "PLAYBOOK_EMPTY_MSG": "Välj Playbook",
    "PLAYBOOK_EMPTY_DESC": "Agent AI kunde inte ladda playbooken eftersom alla tillgängliga playbooks är dynamiska. Klicka på 'Välj Playbook' för att få tillgång till playbooken.",
    "STAGE": "Steg",
    "PROCEED_TO_CLOSE": "Fortsätt för att stänga",
    "RECOMENDED_PLAYBOOK": "REKOMMENDERAD PLAYBOOK",
    "PRIMARY_SCRIPTS": "PRIMÄRA SCRIPTS",
    "DYNAMIC_SCRIPTS": "DYNAMISKA SCRIPTS",
    "RESUME": "Återuppta",
    "ENABLE_CLOSE": "Klicka på fortsätt för att stänga knappen för att aktivera stängningsstadiet",
    "LIST_VIEW": "Listvy",
    "TERMINATE": "Avsluta",
    "MINIMIZE": "Minimera",
    "MAXIMIZE": "Maximera",
    "NO_SEARCH_RESULT": "Inget sökresultat hittades",
    "SENTIMENT_AWAITING": "Väntar på sentiment",
    "POSITIVE": "Positiv",
    "NEGATIVE": "Negativ",
    "ASSOCIATED_WORK_NOTES": "Tidigare lösningsanteckningar",
    "AGENT_JOINED_CONV": "Agenten gick med i konversationen",
    "AUTOSCROLL_ASSIST": "Auto-scroll assistansflikens innehåll",
    "FILE_SIZE_MSG": "Filstorleken måste vara inom 25MB. Försök igen.",
    "OVERRIDE_BTN": "Överskrid",
    "CHOOSE_FILE": "Välj fil",
    "SUMMARY_ERROR_TEXT": "Vi beklagar, men det uppstod ett problem med att skapa sammanfattningen för denna konversation. Vänligen skapa din egen sammanfattning.",
    "ASK_A_QUESTION": "Ställ en fråga",
    "COPY": "Kopiera",
    "TELL_US_MORE": "Berätta mer…",
    "THANKS_FEEDBACK": "Tack för din feedback",
    "SOMETHING_WRONG": "Något gick fel",
    "CLICK_ERROR_DETAILS": "Klicka för att se fel detaljer",
    "NO_ACTIVE_PLAYBOOK": "Ingen aktiv spelbok",
    "REPHRASE_QUESTION": "Kan du omformulera din fråga eller ställa något annat?",
    "VIEW_FULL_ARTICLE_2": "Visa hela artikeln",
    "VIEW_FULL_FILE_2": "Visa hela filen",
    "PLAYBOOK": "Spelboken",
    "INTERNAL_INFO": "Intern information",
    "SOURCES": "Källor",
    "CONVERSATION_SUMMARY": "Sammanfattning av samtal",
    "WAITING": "Väntar",
    "WIDGET_DISABLED": "Widgeten är inaktiverad",
    "AI_SETTINGS_DISABLED": "AI-inställningar är inaktiverade! Kontakta AI-administratören",
    "SERVER_CONNECTION_ERROR": "Fel vid anslutning till servern",
    "VIEW": "Visa",
    "ATTACHMENT_INPUT": "Bilagainmatning",
    "TYPE_SUMMARY": "Skriv sammanfattning",
    "BY":"Av",
    GENERATE_SUMMARY: "Generera sammanfattning",
    PREV_SUMMARIES: "Tidigare genererade sammanfattningar",
    DIALOG_WORKFLOWS: "Dialogarbetsflöden",
    SHOW_ALL_DIALOG: "Visa alla dialoguppgifter",
    SHOW_ALL_DIALOGS: "Visa alla dialoger",
    CUSTOM_TAB: "Anpassad flik",
    AGENT_INPUT: "Agentens indata",
    CUSTOM_EMPTY_MSG: "Ingen aktiv arbetsflöde just nu",
    CUSTOM_TAB_DESC: "För att starta ett arbetsflöde, utför en av objekten i listan som finns längst ner på skärmen.",
    SUBMIT_OVERALL_FEEDBACK: "Skicka overall feedback",
    FEEDBACK_POPUP_SUBTITLE: "Feedback om widgeten och dess funktioner",
    FEEDBACK_SATISFIED: "Nöjd",
    FEEDBACK_UNSATISFIED: "Ej nöjd",
    FEEDBACK_PROVIDE_REASONS: "Förklara ytterligare",
    FEEDBACK_TITLE: "Feedback",
    "AGENTIC_THINKING" : "Tänker",
    "AGENTIC_AGENT_TITLE" : "Agent",
    "AGENTIC_COPILOT_MODE_TITLE" : "Agentic Copilot-läge",
    "AGENTIC_SENDING_MESSAGE" : "Skickar...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilot lyssnar aktivt på ditt samtal och är redo att assistera automatiskt",
    "AGENTIC_SEARCH_RESULTS" : "Agenter Resultat",
    "PAUSE_AUTO_SEND" : "Pausa automatisk sändning",
    "PAUSE_AGENTIC" : "Pausa Agent",
    "RESUME_AGENTIC" : "Återuppta Agent",
    "RESUME_AUTO_SEND" : "Återuppta automatisk sändning"
}
